module.exports = "/packs/images/svg/facilities/children_facilities~7a123ed48b08dff7374a4b1f3caa82f4.svg";